import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICompany_Request, ICompany_Response } from './company.model';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  private endpoint = "company";

  constructor(private apiService: ApiService) { }

  getContactUs(pageNumber: number, pageSize: number) {
    const params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString());
    return this.apiService.getAllPageed<ICompany_Response>({
      Url: `${this.endpoint}/all`,
      Params: params
    });
  }

  getContactUsById(id: number) {
    return this.apiService.get<ICompany_Response>({
      Url: `${this.endpoint}/${id}`,
    });
  }

  createContactUs(body: ICompany_Request) {
    return this.apiService.post<ICompany_Request, ICompany_Response>({
      Url: `${this.endpoint}/contact-us`,
      Body: body
    });
  }

  updateContactUs(jobId: number, job: any) {
    return this.apiService.put<object, ICompany_Response>({
      Url: `${this.endpoint}/${jobId}`,
      Body: job
    });
  }

  deleteContactUs(id: number) {
    return this.apiService.delete<object, object>({
      Url: `${this.endpoint}/${id}`,
      Body: {}
    });
  }
}
